export function apiError(error) {
    return {
        type : 'API_ERROR',
        error
    }
}

function applicationMessageShow(messageType, message, timeout) {
    return {
        type : 'APPLICATION_MESSAGE_SHOW',
        message : {
            type : messageType,
            content : message
        },
        timeout
    }
}

function applicationMessageHide() {
    return {
        type : 'APPLICATION_MESSAGE_HIDE'
    }
}

export function applicationMessage(messageType, message, time = 3000) {
    return dispatch => {
        const timeout = setTimeout(() => {
            console.log('EXECUTING TIMEOUT');
            dispatch(applicationMessageHide())
        }, time);
        dispatch(applicationMessageShow(messageType, message, timeout));
        
    }
}

export function clearApiError() {
    return {
        type : 'API_ERROR_CLEAR'
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/application.js
 **/